import downArrow from "assets/images/account-page/down-arrow.svg";
import upArrowWhite from "assets/images/account-page/up-arrow-white.svg";
import classNames from "classnames";
import { dropdownable } from "components/base/Dropdown";
import React, { useEffect, useRef } from "react";
import css from "./style.scss";
import { isCardExpired } from "../../../utils/validation";

import cardIcon from 'assets/images/creditcard.svg';
import addIcon from 'assets/images/add-green.svg';

const NewCreditCardDropdown = ({
  options = [], // default to [] to avoid undefined errors
  isOpen,
  onClick,
  closeDropdown,
  onChange,
  AddPaymentMethod,
  selectedId,
  selectedCard,
  tag = true,
  paymentMethodType = "ALL",
}) => {
  const dropdownToggleRef = useRef(null);
  const dropdownListRef = useRef(null);

  const handleOptionClick = (option) => {
    if (onChange) onChange(option);
    if (closeDropdown) closeDropdown();
  };

  const handleAddNew = () => {
     AddPaymentMethod();
  };

  useEffect(() => {
    if (options?.length > 0) {
      let sel = null;
      if (selectedId) {
        sel = options.find((o) => o.paymentMethodId === selectedId) || null;
      }

      if (!sel) {
        sel =
          options.find((wallet) =>
            wallet.defaultPaymentMethods?.some(
              (m) => m.paymentMethodType === paymentMethodType
            )
          ) || null;
      }

      if (!sel) {
        sel =
          options.find((wallet) =>
            wallet.defaultPaymentMethods?.some((m) => m.paymentMethodType === "ALL")
          ) || null;
      }

      if (onChange && sel) onChange(sel);
    } else {
      onChange(null);
    }
  }, [options, selectedId, paymentMethodType, onChange]);

  const handleClickOutside = (event) => {
    if (
      dropdownListRef.current &&
      !dropdownListRef.current.contains(event.target) &&
      dropdownToggleRef.current &&
      !dropdownToggleRef.current.contains(event.target)
    ) {
      if (closeDropdown) closeDropdown();
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className={css.dropdown} ref={dropdownToggleRef}>
      {/* Toggle */}
      <div onClick={onClick} role="button" tabIndex={0} onKeyDown={() => {}}>
        <div
          className={classNames(css.clsDropdownCard, {
            [css.clsDropdownCardOpen]: isOpen,
          })}
        >
          <div
            className={classNames(
              css.clsPayCard,
              css.clsPayCardFull,
              css.align_items_center,
              css.justify_content_between,
              "flex-fill"
            )}
          >
            {/* Empty state */}
            {!selectedCard && (
              <div className={css.cardcontainer}>
                <img src={cardIcon} alt="card" className={css.icon} />
                <p className={css.clsMediaTxt1}>Select a Payment Method</p>
              </div>
            )}

            {/* Selected card */}
            {selectedCard && (
              <>
                <div className={css.cardcontainer}>
                  <img
                    src={selectedCard.cardTypeDetails?.image}
                    className="mr-3"
                    alt={selectedCard.cardTypeDetails?.name || "card"}
                  />
                  <div className="clearfix">
                    <h5
                      className={`${css.clsMediaTxt1} ${
                        isCardExpired(selectedCard?.expDate) ? css.text_danger : ""
                      }`}
                    >
                      Ending in {selectedCard.cardEnding}
                    </h5>
                    <p
                      className={`${css.clsMediaTxt2} ${
                        isCardExpired(selectedCard?.expDate) ? css.text_danger : ""
                      }`}
                    >
                      Exp. {selectedCard.expDate}
                    </p>
                  </div>
                </div>

                {tag && (
                  <p className={classNames(css.clsBtnSm, css.clsBtnPrimaryGreen, "mb-0")}>
                    Default for Recurring Services
                  </p>
                )}
              </>
            )}
          </div>

          <a className={css.pl_16} href="#" onClick={(e) => e.preventDefault()}>
            <img src={isOpen ? upArrowWhite : downArrow} alt="" />
          </a>
        </div>
      </div>

      {/* Dropdown list */}
      <div
        className={classNames(css.dropdownList, { [css.open]: isOpen })}
        ref={dropdownListRef}
        aria-hidden={!isOpen}
      >
        {/* No cards → only add */}
        {options.length === 0 && (
          <div
            className={classNames(css.dropdownOptionList, css.addNewRow)}
            onClick={handleAddNew}
            role="button"
            tabIndex={0}
          >
            <img src={addIcon} className={css.addicon} alt="add" />
            <p className={css.dropdownOptionList1}>Add New Payment Method</p>
          </div>
        )}

        {/* List cards */}
        {options.length > 0 &&
          options.map((option, idx) => {
            const expired = isCardExpired(option?.expDate);
            return (
              <div
                key={idx}
                onClick={() => !expired && handleOptionClick(option)}
                className={classNames(css.dropdownOptionList, css.d_flex, css.align_items_center, {
                  [css.disabled]: expired,
                })}
                style={{ cursor: expired ? "not-allowed" : "pointer" }}
                role="button"
                tabIndex={0}
              >
                <img src={option.cardTypeDetails?.image} className="mr-3" alt="card" />
                <div className="clearfix">
                  <p className={`${css.dropdownOptionList1} ${expired ? css.text_danger : ""}`}>
                    Ending in {option.cardEnding}
                  </p>
                  <p className={`${css.dropdownOptionList2} ${expired ? css.text_danger : ""}`}>
                    Exp. {option.expDate}
                  </p>
                </div>
              </div>
            );
          })}

      </div>
    </div>
  );
};

export default dropdownable(NewCreditCardDropdown);
